<div id="createAPost" align="center">
    <form [formGroup]="createPostFormGroup" >
        <button  *ngIf="loading" mat-icon-button  color="primary">
            <mat-spinner diameter="20" ></mat-spinner>
        </button>
        <button mat-icon-button (click)="closeBottomSheet()" class="buttonLeft">
            <mat-icon>close</mat-icon>
        </button>
        <button *ngIf="!loading" (click)="onSubmitCreate(croppedImage)" mat-mini-fab class="buttonRight">
              <mat-icon>send</mat-icon>
        </button>
        <div >
            <div class="textfieldPadding" >
                <input matInput
                [(ngModel)]="message"
                #searchbox
                autocomplete="off"
                formControlName="post_board_text"
                class="textInput"
                placeholder="{{'keyword_$263' | translate}}"
                type="text"
                autocomplete="off">
            </div>
        </div>
        <div class="iconToolBar">
            <div align="center">
                <mat-icon class="buttonInToolBar" (click)="openEmojisToolFunc()" (click)="openEmojis = !openEmojis" (click) ="toggleEmojiPicker()">emoji_emotions</mat-icon>
                <mat-icon class="buttonInToolBar" (click)="openImageToolFunc()" *ngIf="selectedGifUrl == null"  (click)="showImageCropperfunc()">add_a_photo</mat-icon>
                <mat-icon class="buttonInToolBarGrey"  matTooltip="{{'keyword_$405' | translate}}" *ngIf="selectedGifUrl != null" matTooltip="{{'keyword_$405' | translate}}" >add_a_photo</mat-icon>
                <mat-icon class="buttonInToolBar"  (click)="openVideoToolFunc()" >videocam</mat-icon>
                <mat-icon class="buttonInToolBar" (click)="openGifToolFunc()"  *ngIf="croppedImage == ''">gif</mat-icon>
                <mat-icon class="buttonInToolBarGrey" *ngIf="croppedImage != ''" matTooltip="{{'keyword_$405' | translate}}">gif</mat-icon>
            </div>
        </div>
        <br><br>
        <div *ngIf="openVideoTool">
            <mat-form-field >
                <ngx-mat-file-input #video  formControlName="post_board_video" placeholder="{{'keyword_$406' | translate}}" ></ngx-mat-file-input>
                <mat-icon matSuffix>add</mat-icon>
            </mat-form-field>&nbsp; &nbsp;
            <!-- <button mat-raised-button *ngIf="!video.empty" color="warn" (click)="video.clear($event)">{{'keyword_$404' | translate}}</button> -->
        </div>
    </form>
    <div *ngIf="showEmojiPicker">
       <br>
       <emoji-mart class="emoji-mart" set="{{set}}"  (emojiSelect)="addEmoji($event)" title="Pick your emoji…"></emoji-mart>
    </div>
    <form [formGroup]="gifFormGroup"  (ngSubmit)="onSubmitSuche()">
        <div class="" *ngIf="openGifTool">
            <mat-form-field class="filterFollowingUserInput" >
              <input matInput
              placeholder="{{'keyword_$395' | translate}}"
              formControlName="searchValue"
              autocomplete="off"
              #searchValue>
              <mat-icon matSuffix (click)="onSubmitSuche()" >search</mat-icon>
              <mat-hint align="start">{{'keyword_$394' | translate}} </mat-hint>
            </mat-form-field>
        </div>
    </form>
    <div *ngIf="openGifTool">
        <div class="" *ngIf="gifPreview.length != 0">
            <br>
        </div>
        <div class="" *ngIf="oneGifIsSelected ">
            {{'keyword_$392' | translate}} <br>
            <img class="gifPreviewImage" src="{{selectedGifImage}}" >
            <br>
            <button mat-raised-button color="warn" (click)="gifDelete()">{{'keyword_$393' | translate}}</button>
            <br><br>
        </div>
        <ngx-masonry class="masonry-container" [ordered]="true" useImagesLoaded = "true" [options]="{ transitionDuration: '2.00s', gutter: 4, resize:true } " >
                <ngxMasonryItem  class="masonry-item" *ngFor="let gif of gifPreview">
                <div >
                    <img class="gifPreviewImage" (click)="selectedGif(gif)"  src="{{gif.embed_url}}" >
                </div>
                </ngxMasonryItem>
        </ngx-masonry>
    </div>
    <input hidden type="file" #fileInput (change)="fileChangeEvent($event)" (change)="resourcesLoaded = !resourcesLoaded">

    <div class="" *ngIf="errorMsgForFalseImage">
        {{'keyword_$400' | translate}}
    </div>

    <div class="" *ngIf="showImageCropper && openImageTool">

        <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="false"
        [aspectRatio]="4 / 3"
        [resizeToWidth]="600"
        format="png"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()"
        (imageLoaded)="resourcesLoaded = !resourcesLoaded"
        (loadImageFailed)="loadImageFailed()">
        </image-cropper>

        <div class="">
            <button mat-button class="addPictureButton" *ngIf="croppedImage == ''"  (click)="fileInput.click()">{{'keyword_$163' | translate}}</button>
        </div>
        <button mat-raised-button color="warn" *ngIf="croppedImage != ''"  (click)="imageDelete()">{{'keyword_$401' | translate}}</button>

    </div>
</div>



<!-- <mat-spinner *ngIf="resourcesLoaded"></mat-spinner> -->
